import { useParams } from 'react-router-dom';

import { useGetWorkflowQuery } from '../../graphql/queries/GetWorkflow.generated';
import WorkflowCanvas from '../../components/WorkflowBuilder';
import CommandPalette from '../../components/CommandPalette';

const WorkflowDetail = () => {
  const { id } = useParams();
  const { data, loading, error, refetch } = useGetWorkflowQuery({
    variables: { id },
  });

  if (loading) return <div>Loading workflow...</div>;
  if (error) {
    console.error('Error loading workflow:', error);
    return <div>Error loading workflow: {error.message}</div>;
  }
  if (!data?.workflow) return <div>Workflow not found</div>;

  console.log('WorkflowDetail - data.workflow:', data.workflow);
  console.log('WorkflowDetail - workflow.id:', data.workflow.id);

  return (
    <>
      <WorkflowCanvas workflow={data.workflow} onRefetch={refetch} />
      <CommandPalette />
    </>
  );
};

export default WorkflowDetail;
